import { configureStore } from "@reduxjs/toolkit";
import userSlice from "./slice/userSlice";
import offlineSlice from "./slice/offlineSlice";
import indexedDBSlice from "./slice/indexedDBSlice";

const store = configureStore({
  reducer: {
    userReducer: userSlice,
    offlineReducer: offlineSlice,
    indexedDBReducer: indexedDBSlice,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export default store;
